export default {
  init() {
    // JavaScript to be fired on the home page
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
    //Stop Video
    jQuery('#video-modal').on('hidden.bs.modal', function (e) {
      // do something...
      jQuery('#video-modal iframe').attr("src", "");
    });
    jQuery('#video-modal').on('show.bs.modal', function (e) {
      // do something...
      var iframe = jQuery('#video-modal iframe');
      iframe.attr("src", iframe.attr('data-src'));
    });
  },
};




// WEBPACK FOOTER //
// ./scripts/routes/home.js